<template>
    <div class="">
        <div class="form-group">
            <label>Titel des Blocks</label>
            <input type="text" class="form-control" v-model="config.title" placeholder="Rohertrag">
        </div>

        <div class="form-check my-2">
            <input class="form-check-input" type="checkbox" value="" :id="id('regular-profit')"
                   v-model="config.regularProfit">
            <label class="form-check-label" :for="id('regular-profit')">
                Normaler Rohertrag (Netto Ek, tatsächlicher Vk)
            </label>
        </div>

        <div class="form-check my-2">
            <input class="form-check-input" type="checkbox" value="" :id="id('calculated-profit')"
                   v-model="config.calculatedProfit">
            <label class="form-check-label" :for="id('calculated-profit')">
                Kalkulierter Rohertrag (Netto Ek, kalkulierter Vk)
            </label>
        </div>

        <div class="form-check my-2">
            <input class="form-check-input" type="checkbox" value="" :id="id('listen-ek-profit')"
                   v-model="config.listenEkProfit">
            <label class="form-check-label" :for="id('listen-ek-profit')">
                Rohertrag auf Listen Ek (Listen Ek, tatsächlicher Vk)
            </label>
        </div>

        <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
            <label>Sichtbare Spalten:</label>
            <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                <input class="form-check-input"
                       type="checkbox"
                       :id="id(column.id)"
                       :value="column.id"
                       :checked="!config.hiddenColumns.includes(column.id)"
                       @change="toggleHiddenColumns(column.id, $event)">
                <label class="form-check-label" :for="id(column.id)">
                    {{ column.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import blockMixin from "./blockMixin";

export default {
    components: {},
    mixins: [blockMixin],
    props: {

    },
    data() {
        return {
            config: this.dto
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        selectableVisibleColumns() {
            return [
                {id: 'sell-in', label: 'Sell In'},
                {id: 'sell-out', label: 'Sell Out'},
                {id: 'profit-euro', label: 'Rohertrag €'},
                {id: 'profit-percent', label: 'Rohertrag %'},
            ];
        },
    }
}
</script>
